import React from "react";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";

// Import your pages
import SignUpPage from "../pages/sign-up";
import AlreadyEntered from "../pages/simple/already-entered";
import Closed from "../pages/simple/closed";
import PreEntry from "../pages/simple/pre-entry";
import NoWin from "../pages/simple/no-win";
import OutOfHours from "../pages/simple/out-of-hours";
import Success from "../pages/simple/success";
import TermsConditions from "../pages/simple/terms-conditions";
import Scan from "../pages/scan";
import Winner from "../pages/winner";
import Layout from "../components/layout";
import apiInstance from "../api/api";
import routeNames from "../constants/routeNames";
import Prizes from "../pages/prizes";
import Locations from "../pages/locations";

const router = createBrowserRouter([
  {
    element: <Layout />,

    children: [
      {
        index: true,
        element: <SignUpPage />,
        loader: async () => {
          const response = await apiInstance.checkCampaign();
          return response;
        },
      },
      {
        path: routeNames.ALREADY_ENTERED,
        element: <AlreadyEntered />,
      },
      {
        path: routeNames.CLOSED,
        element: <Closed />,
      },
      {
        path: routeNames.PRE_ENTRY,
        element: <PreEntry />,
      },

      {
        path: routeNames.NOT_WINNER,
        element: <NoWin />,
      },
      {
        path: routeNames.OUT_HOURS,
        element: <OutOfHours />,
      },
      {
        path: routeNames.SUCCESS,
        element: <Success />,
      },
      {
        path: routeNames.TERMS,
        element: <TermsConditions />,
      },
      {
        path: routeNames.SCAN,
        element: <Scan />,
      },
      {
        path: routeNames.CONFIRMATION,
        element: <Winner />,
      },
      {
        path: routeNames.LOCATIONS,
        element: <Locations />,
      },
      {
        path: routeNames.PRIZES,
        element: <Prizes />,
      },
      {
        path: "*",
        element: <Navigate to={"/"} />,
      },
    ],
  },
]);

export default function AppRouter() {
  return <RouterProvider router={router} />;
}
